<!--
배송지비용 청구서 작성
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4>
                    <i class="material-icons md-24">add_box</i>
                    <span class="uk-text-middle">배송지비용 청구서 작성</span>
                </h4>
            </div>

            <div class="uk-modal-body uk-padding-remove">
                <table class="input-table">
                <tr v-show="! prodId">
                    <th>
                        <i class="material-icons">
                            account_circle
                        </i>
                        회원사
                    </th>
                    <td colspan="3">
                        <app-input-search-select
                            :options="regionMemberOptions"

                            v-model="userId"
                            placeholder="회원사를 선택하세요"
                        > </app-input-search-select>
                    </td>
                </tr>

                <!-- 로그성 상품정보 -->
                <tr v-show="prodId">
                    <th>
                        <i class="material-icons">
                            account_circle
                        </i>
                        회원사
                    </th>
                    <td>
                        {{ userNick }}
                    </td>
                    <th>
                        <i class="material-icons">
                            tag
                        </i>
                        상품번호
                    </th>
                    <td>
                        {{ prodId }}
                    </td>
                </tr>

                <tr v-show="prodId">
                    <th>
                        <i class="material-icons">
                            tag
                        </i>
                        배송코드
                    </th>
                    <td>
                        {{ houseCode }}
                    </td>
                    <th>
                        <i class="material-icons">
                            account_box
                        </i>
                        수취인
                    </th>
                    <td>
                        {{ houseName }}
                    </td>
                </tr>

                <tr v-show="prodId">
                    <th>
                        <i class="material-icons">
                            location_on
                        </i>
                        배송지
                    </th>
                    <td>
                        {{ shippingCenter }}
                    </td>

                    <th>
                        <i class="material-icons">
                            local_shipping
                        </i>
                        트래킹번호
                    </th>
                    <td>
                        {{ trackingNo }}
                    </td>
                </tr>

                <tr>
                    <th>
                        <i class="material-icons">
                            iso
                        </i>
                        과금방식
                    </th>
                    <td>
                        <app-input-select
                            :options="chargeTypeOptions"
                            v-model="chargeType"
                        > </app-input-select>
                    </td>

                    <th>
                        <i class="material-icons">
                            attach_money
                        </i>
                        청구비용({{ regionCurrency }})
                    </th>
                    <td>
                        <app-input-text
                            v-model="cost"

                            :validate-rules="{required: true}"
                            required
                            required-layout="label-left"

                            :placeholder="regionCurrency+' (소수 2자리)'"
                        > </app-input-text>
                    </td>
                </tr>

                <tr>
                    <th>
                        <i class="material-icons">
                            comment
                        </i>
                        청구내용(메모)
                    </th>
                    <td colspan="3">
                        <app-input-textarea
                            :textarea-rows="5"

                            v-model="memo"
                            label="청구내용(메모)"

                            :validate-rules="{required: true}"
                            required
                            required-layout="label-left"

                            placeholder="상세하게 작성하세요"
                        > </app-input-textarea>
                    </td>
                </tr>
                </table>








            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    작성완료
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 지역ID
                regionId: null,

                // 영업소ID
                agentId: null,

                // 사용자ID
                userId: null,

                // 사용자Nick
                userNick: null,

                // 상품ID
                prodId: null,

                // 배송코드
                houseCode: null,

                // 수취인
                houseName: null,

                // 배송지
                shippingCenter: null,

                // 트래킹
                trackingNo: null,

                // (string) 과금방식
                chargeType: null,

                // (float) 청구비용
                cost: null,

                // (string) 메모
                memo: null,

                // (array) 지역 회원사 옵션
                regionMemberOptions: [],

                // (array) 과금방식 옵션
                chargeTypeOptions: [],

                // (string) 지역 화폐
                regionCurrency: null,
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param region_id
             * @param agent_id
             * @param user_id
             * @param prod_id
             */
            form(region_id, agent_id, user_id, prod_id) {

                // 초기화
                this.regionId = region_id;
                this.agentId = agent_id;
                this.userId = user_id;
                this.userNick = null;
                this.prodId = prod_id;
                this.houseCode = null;
                this.houseName = null;
                this.shippingCenter = null;
                this.trackingNo = null;
                this.chargeType = '1';
                this.cost = null;
                this.memo = null;
                this.regionMemberOptions = [];
                this.chargeTypeOptions = [];
                this.regionCurrency = null;

                // 조회
                this.loadPromise()
                    .then((response) => {
                        // 결과저장
                        this.regionMemberOptions = response.region_member_options;
                        this.chargeTypeOptions = response.charge_type_options;
                        this.regionCurrency = response.region_currency;

                        if (response.prod) {
                            this.houseCode = response.prod.house_code;
                            this.houseName = response.prod.house_name;
                            this.shippingCenter = response.prod.shipping_center;
                            this.trackingNo = response.prod.tracking_no;
                        }


                        this.userNick = response.user_nick;

                        // 폼띄우기
                        this.displayForm();

                    });
            },

            /**
             * 초기정보 조회
             */
            loadPromise() {
                // promise 생성
                return new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/regions/' + this.regionId + '/shipping-center-cost-create-init-data',
                        data: {
                            'user_id': this.userId,
                            'prod_id': this.prodId,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            // promise 실패
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            },


            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/shipping-center-costs',
                    data: {
                        '_token': this.csrfToken,
                        'region_id': this.regionId,
                        'agent_id': this.agentId,
                        'user_id': this.userId,
                        'prod_id': this.prodId,
                        'charge_type': this.chargeType,
                        'cost': this.cost,
                        'memo': this.memo,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 테이블
    .input-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            text-align: left;
            border: 1px solid #cfcfcf;
            font-weight: normal;

            padding: 1rem;
            color: #000;
        }

        th {

            font-size: 1rem;
            background-color: #fefefe;
            width: 10rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.25rem;
                color: #aaa;
            }

        }
        td {
            text-align: center;
            font-size: 1rem;
            color: #000;
        }

    }
</style>